import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const userChangePasswordFn = (data) => apiClient.post(`${APP_SSO_URL}api/user/change-password`, data);

export const useUserChangePasswordMutation = () => {
  return useMutation({
    mutationFn: userChangePasswordFn,
  });
};
